<div class="xl:flex" *ngIf="ticket">
    <div class="xl:flex-1">
        <section class="flex-center mb-2 flex flex-col justify-center gap-4 py-8 md:justify-start">
            <rwidget-ticket-qr *ngIf="showQrCode" [ticket]="ticket" (qrClick)="qrClick()"></rwidget-ticket-qr>

            <section
                class="aztecCode flex-column flex h-[9rem] w-40 items-center justify-center bg-gray-100 p-10 text-danger"
                *ngIf="ticket.status === 'EXPIRED' || ticket.status === 'CANCELLED' || ticket.status === 'REFUNDED'">
                <span class="uppercase" [ngSwitch]="ticket.status">
                    <ng-container *ngSwitchCase="'CANCELLED'">{{ 'RIDE_STATUS_CANCELLED' | translate }}</ng-container>
                    <ng-container *ngSwitchCase="'EXPIRED'">{{ 'TICKET_EXPIRED' | translate }}</ng-container>
                    <ng-container *ngSwitchCase="'REFUNDED'">{{ 'TICKET_REFUNDED' | translate }}</ng-container>
                </span>
                <span *ngIf="ticket.status === 'EXPIRED'">
                    {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                </span>
                <span *ngIf="ticket.status === 'REFUNDED' && env.SHOW_HISTORY_TICKET_REFUND_DATES && isHistoryTicket">
                    {{ ticket.timestamps?.refundTimestamp | formatTimeZone: dateTimeFormat : timezone }}
                </span>
                <span
                    *ngIf="ticket.status === 'CANCELLED' && env.SHOW_HISTORY_TICKET_CANCELED_DATES && isHistoryTicket">
                    {{ ticket.timestamps?.cancellationTimestamp | formatTimeZone: dateTimeFormat : timezone }}
                </span>
            </section>

            <p class="text-xs font-medium text-grey-dark" *ngIf="env.ZOOMABLE_QR_CODE">
                {{ 'TAP_TO_ZOOM' | translate }}
            </p>
        </section>

        <section class="mb-2 pb-2">
            <section class="bg-primary-light mb-2 flex flex-col rounded-2xl" *ngIf="ticket.status === 'ACTIVE'">
                <h3 class="pb-1 text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                    {{ 'PRODUCT_TYPE' | translate }}
                </h3>
                <span>{{ 'ACTIVE_TICKET' | translate }}</span>
                <span>
                    {{ ticket.startDate | formatTimeZone: dateTimeFormat : timezone }}
                    -
                    {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                </span>
            </section>
            <h3 class="pb-2 text-base font-normal">{{ ticketTitle | async }}</h3>

            <h3 class="pb-1 text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                {{ 'PRODUCT_TYPE' | translate }}
            </h3>
            <p class="pb-2 text-base">
                {{ ticket.typeOfProduct?.name | translateObjectField: 'translations' : currentLang }}
            </p>

            <ng-container *ngIf="ticket?.userProfiles?.length">
                <h3 class="pb-1 text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                    {{ 'USER_PROFILE' | translate }}
                </h3>
                <p class="pb-2 text-base">{{ travellers }}</p>
            </ng-container>
        </section>

        <ng-container *ngIf="ticket?.geography?.zones?.length">
            <h3 class="pb-1 text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                {{ 'GEOGRAPHY' | translate }}
            </h3>
            <p class="text-base">
                {{ ticket.geography.zones[0]?.name | translateObjectField: 'translations' : currentLang }}
            </p>
        </ng-container>

        <ion-accordion-group [(value)]="accordionValue">
            <ion-accordion value="detailsShown">
                <ion-item class="left-padding-0 chevron-hidden" slot="header">
                    <ion-label class="cursor-pointer font-semibold !text-secondary dark:text-contrast-yellow">
                        {{ (accordionValue ? 'CART_TICKET_HIDE_DETAILS' : 'CART_TICKET_SHOW_DETAILS') | translate }}
                    </ion-label>
                </ion-item>
                <div class="ion-padding" slot="content">
                    <section
                        class="mb-2 border-b border-t border-solid border-black border-opacity-10 pb-2 pt-2"
                        *ngIf="ticket.timeIntervals?.length">
                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'PRODUCT_VALIDITY' | translate }}
                        </h3>
                        <p class="text-base">
                            {{ ticket.timeIntervals[0]?.name | translateObjectField: 'translations' : currentLang }}
                        </p>
                    </section>

                    <section class="mb-2 border-b border-solid border-black border-opacity-10 pb-2">
                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'CART_TICKET_NUMBER' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.id }}</p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'PRICE_PAID' | translate }}
                        </h3>
                        <p class="text-base">
                            {{ ticket.price | moneyFormat }} {{ ticket.price.currency | translate }}
                        </p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'CART_PAYMENT_METHOD' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.paymentMethods?.[0] }}</p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow" *ngIf="ticket.issuer">
                            {{ 'TICKET_ISSUER' | translate }}
                        </h3>
                        <p class="text-base" *ngIf="ticket.issuer">{{ ticket.issuer.name }}</p>
                    </section>

                    <section class="mb-2 border-solid border-black border-opacity-10 pb-2">
                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'ACTIVE_PERIOD' | translate }}
                        </h3>
                        <p class="text-base">
                            {{ ticket.startDate | formatTimeZone: dateTimeFormat : timezone }}
                            -
                            {{ ticket.endDate | formatTimeZone: dateTimeFormat : timezone }}
                        </p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'CARD_STATUS_PURCHASE_HISTORY' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.status }}</p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'PURCHASED_ON' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.purchaseAt | formatTimeZone: dateTimeFormat : timezone }}</p>
                    </section>

                    <section class="mb-2 pb-4" *ngIf="ticket.school">
                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'CHOOSE_TRAVELLER_PROFILE' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.school.traveller }}</p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'DOB' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.school.dob }}</p>

                        <h3 class="text-xs font-medium text-gray-500 dark:text-contrast-yellow">
                            {{ 'SCHOOL' | translate }}
                        </h3>
                        <p class="text-base">{{ ticket.school.name }}</p>
                    </section>

                    <section
                        class="sr-app-light:pt-2 py-4 font-bold"
                        *ngIf="this.authService.getLoginStatus() && this.env.IS_NEW_AFC"></section>
                </div>
            </ion-accordion>
        </ion-accordion-group>
    </div>

    <div class="var-app-light-dark:flex var-app-light-dark:flex-col py-4">
        <ng-container *ngFor="let action of ticketBtns">
            <button
                class="box-border w-full p-4 py-4 text-center text-base font-semibold text-primary dark:text-contrast-black"
                [class]="action.cssClass"
                [disabled]="action.disabled"
                (click)="action.handler()">
                {{ action.text }}
            </button>
        </ng-container>
    </div>
</div>
